import { useEffect, useRef, type VFC } from 'react'
import { useIsMounted } from '@panwds/react-ui'
import LoadingPlaceholder from '../common/LoadingPlaceholder'
import { isPromiseLike } from '../../framework/utils'

const LoadingPromisePlaceholder: VFC<{ promise: Promise<unknown>, onResolved: () => void }> = ({ promise, onResolved }) => {
  const isMountedRef = useIsMounted()
  const onResolvedRef = useRef(onResolved)
  onResolvedRef.current = onResolved
  useEffect(() => {
    if (!onResolvedRef.current || !isMountedRef.current || !isPromiseLike(promise)) {
      return
    }
    if ('resolved' in promise) {
      onResolvedRef.current()
    }
    else {
      promise.then(() => {
        if (isMountedRef.current && onResolvedRef.current) {
          onResolvedRef.current()
        }
      }) // not handling rejection for now
    }
  }, [isMountedRef, promise])
  return <LoadingPlaceholder />
}

export default LoadingPromisePlaceholder
